<template>
  <!-- 菜单管理 -->
  <div class="wrapper">
    <div class="btn-group">
      <div></div>
      <div>
        <el-button
          v-show="isShowBtn('MenuAdd')"
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="goAddRootMenu"
        >添加</el-button>
      </div>
    </div>
    <el-table
      :data="list"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :header-row-style="{ height: '50px', color: '#626e7c' }"
      :cell-style="changeTr"
      :header-cell-style="changeHeader"
    >
      <el-table-column
        label="名称"
        align="left"
        width="280px"
      >
        <template slot-scope="scope">{{ scope.row.menu_name }}</template>
      </el-table-column>
      <el-table-column
        label="菜单类型"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-tag v-if="scope.row.auth_type == 1" type="success">目录</el-tag> -->
          <el-tag
            v-if="scope.row.auth_type == 1"
            type="info"
          >菜单</el-tag>
          <el-tag
            v-if="scope.row.auth_type == 2"
            type="warning"
          >按钮</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-link
            v-show="isShowBtn('MenuAdd')"
            type="primary"
            @click="goAdd(scope.row)"
          >添加</el-link>
          <el-link
            v-show="isShowBtn('MenuEdit')"
            style="margin: 0 10px"
            type="primary"
            @click="goEdit(scope.row)"
          >编辑</el-link>
          <el-link
            v-show="isShowBtn('MenuDel')"
            style="margin-left: 10px"
            slot="reference"
            type="danger"
            @click="apiDelMenu(scope.row.id)"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增编辑 -->
    <el-dialog
      :title="formData.id ? '编辑' : '新增'"
      :visible.sync="show_menu"
      width="width"
    >
      <el-form
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item label="上级菜单">
          <MenuTreeSelect
            ref="menutree"
            v-model="formData.pid"
          ></MenuTreeSelect>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="menu_name"
        >
          <el-input
            style="width: 250px"
            v-model="formData.menu_name"
            size="small"
            placeholder="名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="菜单类型"
          prop="auth_type"
        >
          <el-select
            style="width: 250px"
            v-model="formData.auth_type"
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option
              label="菜单"
              :value="1"
            > </el-option>
            <el-option
              label="按钮"
              :value="2"
            > </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="权限标识"
          prop="unique_auth"
        >
          <el-input
            style="width: 250px"
            v-model="formData.unique_auth"
            size="small"
            placeholder="权限标识"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="sort"
        >
          <el-input
            style="width: 250px"
            v-model="formData.sort"
            size="small"
            placeholder="排序"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          @click="show_menu = false"
          size="small"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="submit"
          size="small"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMenusTree, delMenu, getMenuDetail, addMenu, editMenu } from './api'
import { authBtnMixin } from '@/mixins/authBtnMixin'
import MenuTreeSelect from './menu-tree-select.vue'
export default {
  name: 'Index',
  mixins: [authBtnMixin],
  components: { MenuTreeSelect },
  data () {
    return {
      show_menu: false,
      list: [],

      formData: {
        pid: 0,
        menu_name: '', //菜单名称
        auth_type: '', //菜单类型
        unique_auth: '', //权限标识
        sort: 1
      }
    }
  },
  provide () {
    return {
      context: this
    }
  },
  mounted () {
    this.apiQueryMenuTree()
  },
  methods: {
    // 添加一级菜单
    goAddRootMenu () {
      this.show_menu = true
      this.formData = {
        pid: 0,
        menu_name: '', //菜单名称
        auth_type: '', //菜单类型
        unique_auth: '', //权限标识
        sort: 1
      }

      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.$refs.menutree.getMenusTree()
      })
    },
    // 添加子菜单
    goAdd (row) {
      const { id, pid } = row
      this.formData = {
        pid: id,
        menu_name: '', //菜单名称
        auth_type: '', //菜单类型
        unique_auth: '', //权限标识
        sort: 1
      }
      this.show_menu = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.$refs.menutree.getMenusTree()
      })
    },
    async goEdit (row) {
      const { id } = row

      this.show_menu = true
      this.$nextTick(async () => {
        this.formData = await getMenuDetail(id)
        this.$refs.form.resetFields()
        this.$refs.menutree.getMenusTree()
      })
    },
    // 提交
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            editMenu(this.formData).then(() => {
              this.apiQueryMenuTree()
              this.show_menu = false
              this.$message({
                type: 'success',
                message: '编辑成功!'
              })
            })
          } else {
            addMenu(this.formData).then(() => {
              this.apiQueryMenuTree()
              this.show_menu = false
              this.$message({
                type: 'success',
                message: '添加成功!'
              })
            })
          }
        }
      })
    },
    async apiQueryMenuTree () {
      let res = await getMenusTree()
      this.list = res || []
    },

    async apiDelMenu (id) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delMenu(id).then(() => {
            this.apiQueryMenuTree()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 修改第一列无children的样式
    changeTr ({ row, column, rowIndex, columnIndex }) {
      if (!row.children && columnIndex == 0) {
        return { paddingLeft: '100px' }
      }
      if (columnIndex == 0) {
        return { paddingLeft: '100px' }
      }
    },
    changeHeader ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return { background: '#f8f9fb', padding: '8px 0 0 130px' }
      } else {
        return { background: '#f8f9fb', padding: '8px 0' }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  ::v-deep.one-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }

  // .el-table ::v-deep {
  //   border-top-left-radius: 5px;
  //   border-top-right-radius: 5px;
  // }
  .btn-group {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
</style>
